<script lang="ts" setup>
// TODO провести рефакторинг
import './style.scss';

import Simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';

const className = 'ui-scroll-wrap';
</script>

<template>
  <Simplebar
    data-simplebar-auto-hide="false"
    data-simplebar-scrollable-x="false"
    data-simplebar-scrollable-y
    :tab-index="-1"
    :class="className"
  >
    <slot />
  </Simplebar>
</template>
